import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollToTop from './components/helpers/ScrollToTop';
import AuthRoutes from './routes/AuthRoutes';
import Login from './views/login/Login';
import './App.css';
import Signup from './views/signup/Signup';
import Playground from './views/Playground';
import {
  authLogin,
  getUserNotifications,
  reloadSession,
  userLoginSuccess,
} from './store/actions/authentication.action';
import { checkAuth, getUser } from './utils/helpers/helper';
import store from './store/store';

export const NavbarContext = React.createContext();

const userDetail = {};
if (localStorage.token) {
  const isAuthenticated = checkAuth();
  if (isAuthenticated) {
    //dispatch user details
    const data = getUser();
    store.dispatch(userLoginSuccess(data));
    store.dispatch(reloadSession(data?.user?.id));
    store.dispatch(getUserNotifications());
  } else {
    store.dispatch(authLogin(userDetail));
  }
} else {
  store.dispatch(authLogin(userDetail));
}

function App() {
  const [showLargeScreenNav, setLargeScreenNav] = useState(false);
  const handleOpenLargeScreenNav = () => {
    setLargeScreenNav(!showLargeScreenNav);
  };

  return (
    <NavbarContext.Provider
      value={{ handleOpenLargeScreenNav, showLargeScreenNav }}
    >
      <div className="App">
        <Router>
          <ScrollToTop />
          <Switch>
            {/* <Route exact path="/">
              <Login />
            </Route> */}
            <Route exact path="/login">
              {/* <Login /> */}
            </Route>
            <Route exact path="/signup">
              {/* <Signup /> */}
            </Route>
            <Route exact path="/play">
              <Playground />
            </Route>
            <AuthRoutes />
          </Switch>
        </Router>
      </div>
    </NavbarContext.Provider>
  );
}

export default App;
